import React, {memo, useEffect, useState} from 'react'
import cx from 'classnames'

/* Components */
import VoltranFragment from '../../../../components/VoltranFragment/VoltranFragment'
import HorizontalProductsSkeleton from '../../../../components/HorizontalProductsSkeleton/HorizontalProductsSkeleton'

/* Constants */
import {
  DESKTOP_COMPONENTS,
  DESKTOP_COMPONENTS_OPTIONS
} from '../../../../modules/voltran/voltranConstants'

/* Styles */
import s from './recommendation.scss'

const Recommendation = memo(({
  componentData,
  fragmentsMap,
  isAvailableProduct,
  isBot,
}) => {
  const [recommendationStatus, setRecommendationStatus] = useState({})
  useEffect(() => {
    handleRecommendationFetchListener()
  }, [])

  const handleRecommendationFetchListener = () => {
    window.HbEventBus.on(`storefront.voltran.recommendation-${componentData?.placementId}-fetched`, (status) => {
      setRecommendationStatus((prevState) => ({
        ...prevState,
        [`${componentData?.placementId}`]: status,
      }))
    });

    return () => {
      // eslint-disable-next-line no-empty-function
      window.HbEventBus?.off(`storefront.voltran.recommendation-${componentData?.placementId}-fetched`, () => {
      })
    }
  }

  return (
    <div
      id={`recommendation-${componentData?.placementId}`}
      className={
        cx(
          s.root,
          {
            [s.active]:
            typeof recommendationStatus[componentData?.placementId] === 'boolean' &&
            recommendationStatus[componentData?.placementId]
          },
          {
            [s.hidden]:
            typeof recommendationStatus[componentData?.placementId] === 'boolean' &&
            !recommendationStatus[componentData?.placementId]
          },
          {
            [s.botAgent]: isBot
          }
        )
      }
      data-test-id={`recommendation-${componentData?.placementId}`}>
      {
        !fragmentsMap?.get(componentData?.placementId) &&
        <HorizontalProductsSkeleton className={s.skeleton} cardClassName={s.placeholderCard} cardCount={7}/>
      }
      <VoltranFragment
        fragmentInfo={fragmentsMap?.get(componentData?.placementId)}
        options={{
          ...DESKTOP_COMPONENTS_OPTIONS[DESKTOP_COMPONENTS.RECOMMENDATION],
          scriptsLoadEagerly: !isAvailableProduct,
          onlyClientSide: isBot ? false : isAvailableProduct
        }}
        render={isBot ? true : !isAvailableProduct}
        renderMethodClientSide={isBot ? true : process.env.BROWSER}
        removeClientStyles
      />
    </div>
  )
})

export default Recommendation
